module.exports = __webpack_public_path__ + "img/cloud.7b7ad649.svg";